import { combineReducers } from "@reduxjs/toolkit";
import { authApiService } from "../Apis/Auth";
import { bmifitnessApiService } from "../Apis/Calculator/BMI";
import { bmrfitnessApiService } from "../Apis/Calculator/BMR";
import { bodyfatfitnessApiService } from "../Apis/Calculator/BodyFat";
import { heartratefitnessApiService } from "../Apis/Calculator/HRC";
import { hydrationfitnessApiService } from "../Apis/Calculator/Hydration";
import { ibwfitnessApiService } from "../Apis/Calculator/IBW";
import { macrofitnessApiService } from "../Apis/Calculator/Macro";
import { onerepmaxfitnessApiService } from "../Apis/Calculator/ORM";
import { sleepfitnessApiService } from "../Apis/Calculator/Sleep";
import { whrfitnessApiService } from "../Apis/Calculator/WHR";
import { campaignApiService } from "../Apis/Campaign";
import { categoryApiService } from "../Apis/Category";
import { courseApiService } from "../Apis/Course";
import { dashboardApiService } from "../Apis/Dashboard";
import { digitalProductsApiService } from "../Apis/DigitalProducts";
import { discussionApiService } from "../Apis/Discussion";
import { faqApiService } from "../Apis/FAQ";
import { feedbackApiService } from "../Apis/Feedback";
import { balancefitnessApiService } from "../Apis/FitnessTest/Balance";
import { cardiofitnessApiService } from "../Apis/FitnessTest/Cardio";
import { flexibilityfitnessApiService } from "../Apis/FitnessTest/Flexibility";
import { strengthfitnessApiService } from "../Apis/FitnessTest/Strength";
import { funnelApiService } from "../Apis/Funnel";
import { generalApiService } from "../Apis/General";
import { generateCertificateApiService } from "../Apis/GenerateCertificate";
import { guidelineApiService } from "../Apis/Guideline";
import { guidelineactionApiService } from "../Apis/GuidelineAction";
import { homefeaturedcontrolApiService } from "../Apis/HomeFeaturedControl";
import { newsletterApiService } from "../Apis/Newsletter";
import { notificationApiService } from "../Apis/Notification";
import { accesspackageApiService } from "../Apis/PackageAccess";
import { packageApiService } from "../Apis/Packages";
import { plannerApiService } from "../Apis/Planner";
import { pressApiService } from "../Apis/Press";
import { profileOtherApiService } from "../Apis/ProfileOthers";
import { promotecourseApiService } from "../Apis/PromoteCourse";
import { pssApiService } from "../Apis/PSSWorkSpace";
import { quizApiService } from "../Apis/Quiz";
import { reviewApiService } from "../Apis/Review";
import { templateApiService } from "../Apis/Template";
import { trackLectureApiService } from "../Apis/TrackLecture";
import { userApiService } from "../Apis/User";
import { userFollowerApiService } from "../Apis/UserFollower";
import authReducer from "../Slices/Auth";
import calculatorReducer from "../Slices/Calculator";
import generalReducer from "../Slices/General";
import languageReducer from "../Slices/Language";
import translationReducer from "../Slices/Translation";

const rootReducer = combineReducers({
  generalSlice: generalReducer,
  authSlice: authReducer,
  calculatorSlice: calculatorReducer,
  language: languageReducer,
  translations: translationReducer,
  [authApiService.reducerPath]: authApiService.reducer,
  [generalApiService.reducerPath]: generalApiService.reducer,
  [courseApiService.reducerPath]: courseApiService.reducer,
  [digitalProductsApiService.reducerPath]: digitalProductsApiService.reducer,
  [categoryApiService.reducerPath]: categoryApiService.reducer,
  [feedbackApiService.reducerPath]: feedbackApiService.reducer,
  [guidelineApiService.reducerPath]: guidelineApiService.reducer,
  [guidelineactionApiService.reducerPath]: guidelineactionApiService.reducer,
  [newsletterApiService.reducerPath]: newsletterApiService.reducer,
  [packageApiService.reducerPath]: packageApiService.reducer,
  [pressApiService.reducerPath]: pressApiService.reducer,
  [userApiService.reducerPath]: userApiService.reducer,
  [reviewApiService.reducerPath]: reviewApiService.reducer,
  [generateCertificateApiService.reducerPath]:
    generateCertificateApiService.reducer,
  [quizApiService.reducerPath]: quizApiService.reducer,
  [bmifitnessApiService.reducerPath]: bmifitnessApiService.reducer,
  [bmrfitnessApiService.reducerPath]: bmrfitnessApiService.reducer,
  [bodyfatfitnessApiService.reducerPath]: bodyfatfitnessApiService.reducer,
  [macrofitnessApiService.reducerPath]: macrofitnessApiService.reducer,
  [heartratefitnessApiService.reducerPath]: heartratefitnessApiService.reducer,
  [ibwfitnessApiService.reducerPath]: ibwfitnessApiService.reducer,
  [dashboardApiService.reducerPath]: dashboardApiService.reducer,
  [discussionApiService.reducerPath]: discussionApiService.reducer,
  [profileOtherApiService.reducerPath]: profileOtherApiService.reducer,
  [hydrationfitnessApiService.reducerPath]: hydrationfitnessApiService.reducer,
  [onerepmaxfitnessApiService.reducerPath]: onerepmaxfitnessApiService.reducer,
  [sleepfitnessApiService.reducerPath]: sleepfitnessApiService.reducer,
  [whrfitnessApiService.reducerPath]: whrfitnessApiService.reducer,
  [balancefitnessApiService.reducerPath]: balancefitnessApiService.reducer,
  [cardiofitnessApiService.reducerPath]: cardiofitnessApiService.reducer,
  [flexibilityfitnessApiService.reducerPath]:
    flexibilityfitnessApiService.reducer,
  [strengthfitnessApiService.reducerPath]: strengthfitnessApiService.reducer,
  [faqApiService.reducerPath]: faqApiService.reducer,
  [promotecourseApiService.reducerPath]: promotecourseApiService.reducer,
  [campaignApiService.reducerPath]: campaignApiService.reducer,
  [pssApiService.reducerPath]: pssApiService.reducer,
  [templateApiService.reducerPath]: templateApiService.reducer,
  [notificationApiService.reducerPath]: notificationApiService.reducer,
  [plannerApiService.reducerPath]: plannerApiService.reducer,
  [funnelApiService.reducerPath]: funnelApiService.reducer,
  [homefeaturedcontrolApiService.reducerPath]:
    homefeaturedcontrolApiService.reducer,
  [trackLectureApiService.reducerPath]: trackLectureApiService.reducer,
  [accesspackageApiService.reducerPath]: accesspackageApiService.reducer,
  [userFollowerApiService.reducerPath]: userFollowerApiService.reducer,
});

export default rootReducer;
